'use client';

import { useTranslations } from 'next-intl';

import { H2, P } from '@/components/shared/Typography';
import { cn } from '@/lib/utils/cn';
import { formatNumberWithCommasAndDecimals } from '@/lib/utils/formatNumberWithCommasAndDecimals';

export interface I_Winner {
  rank: number;
  name: string;
  predicted: string;
  won: string;
  entryTime?: string;
  userAddress?: string;
  avatar?: {
    url: string;
    alt: string;
  };
}

function WinnerPrimeCard({
  winners,
  connectedAddress,
  decimals
}: {
  winners: I_Winner[];
  connectedAddress?: string | undefined;
  decimals?: number;
}) {
  const t = useTranslations();
  const decimalPlaces = decimals || 2;
  return (
    <div className="overflow-y-auto space-y-3 max-h-87">
      {winners.map(winner => {
        const isUserEntry =
          connectedAddress &&
          winner.userAddress &&
          winner.userAddress.toLowerCase() === connectedAddress.toLowerCase();

        return (
          <div
            key={winner.rank}
            className={cn(
              'w-full p-4 cursor-pointer rounded-10 outline-1 outline-offset-[-1px] transition-colors duration-[0.4s] flex justify-start items-center gap-2.5',
              isUserEntry ? 'outline-primary' : 'outline-base-border/20'
            )}
          >
            <div className="w-6 flex justify-center items-center">
              <H2 className="text-center text-foreground text-3xl font-semibold leading-9">
                {winner.rank}
              </H2>
            </div>

            <div className="flex-1 flex flex-col items-start">
              <P className="text-foreground text-sm font-semibold leading-5">
                {winner.name}
              </P>
              <P className="text-foreground text-xs font-light leading-4 whitespace-nowrap ">
                {t('profile.predictionWinners.predicted')}{' '}
                {formatNumberWithCommasAndDecimals(
                  winner.predicted,
                  decimalPlaces
                )}
              </P>
            </div>

            <div className="max-sm:flex-1 flex justify-start items-center gap-2.5">
              <P className="flex-1 text-center text-primary text-sm font-bold leading-5">
                {t('profile.predictionWinners.won')}
                <br />
                {winner.won}
              </P>

              {winner.entryTime && (
                <P className="max-sm:min-w-20 md:min-w-30 justify-end flex-1 text-right text-muted-foreground text-sm font-normal leading-5">
                  {t('profile.predictionWinners.entryTime')} <br />{' '}
                  {winner.entryTime}
                </P>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default WinnerPrimeCard;
